var PRICE_INPUT_REGEX = /^\d+(?:[.,]\d{1,2})?$/;
var stripWhitespace = function (value) { return value.replace(/\s/g, ""); };
export var isValidPriceInput = function (value) {
    var stripped = stripWhitespace(value);
    if (stripped === "")
        return false;
    return PRICE_INPUT_REGEX.test(stripped);
};
export var priceInputToMinorUnits = function (value) {
    var normalized = stripWhitespace(value).replace(",", ".");
    var _a = normalized.split("."), whole = _a[0], _b = _a[1], fraction = _b === void 0 ? "" : _b;
    var paddedFraction = (fraction + "00").slice(0, 2);
    return Number(whole) * 100 + Number(paddedFraction);
};
export var minorUnitsToPriceInput = function (amount) {
    var whole = Math.trunc(amount / 100);
    var fraction = Math.abs(amount % 100);
    return "".concat(whole, ",").concat(fraction.toString().padStart(2, "0"));
};
export var formatPriceForDisplay = function (amount, currency) {
    var value = amount / 100;
    var formatted = new Intl.NumberFormat("cs-CZ", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value);
    return currency ? "".concat(formatted, " ").concat(currency) : formatted;
};
